import { dataSlice as createDataSLice } from '../../../core/data';
import {
  combineReducers,
  createAction,
  createSelector,
} from '@reduxjs/toolkit';
import _ from 'lodash';
import { DataConf } from '../conf/Data.conf';
import { DetailConf } from '../conf/Detail.conf';
import { detailSlice as createDetailSlice } from '../../../core/detail';

import dayjs from 'dayjs';

export const tag = 'delivery_notes';

// REDUCERS
const dataSlice = createDataSLice(`${tag}/data`, DataConf.initialState);
const detailSlice = createDetailSlice(`${tag}/detail`, DetailConf.initialState);

export const reducer = combineReducers({
  data: dataSlice.reducer,
  detail: detailSlice.reducer,
});

// ACTIONS
export const actions = {
  fetchDetailAction: createAction(`${tag}/fetchOne`),
  ...dataSlice.actions,
  ...detailSlice.actions,
};

// EDIT
export const editSelector = createSelector(
  (state) => state[tag].detail,
  ({ data, loading, error }) => {
    const note = _.get(data, 'attributes.note');
    const logbook = _.get(data, 'attributes.id_logbook.data');
    return {
      loading,
      error,
      data: data
        ? {
            date: dayjs(),
            note: note || '',
            delivery_note_number: _.get(
              data,
              'attributes.delivery_note_number'
            ),
            id_logbook: logbook
              ? {
                  id: logbook?.id,
                  label: `${logbook?.attributes?.id_supplier?.data?.attributes?.mexal_code} - ${logbook?.attributes?.id_supplier?.data?.attributes?.label} (${
                    logbook?.attributes?.status_logbook
                  })`,
                  id_list_items: logbook?.attributes?.id_list_items,
                }
              : '',
          }
        : null,
    };
  }
);
